import React from 'react';
import './TopBar.css';

const TopBar = () => {
  return (
    <div className="top-bar-wrapper">
      
    </div>
  );
};

export default TopBar;
